(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fyre-section-blog-featured"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-blog-featured-slider]').forEach(function (slider) {
    var container = slider.closest('.blog-featured');
    if (!container) return;
    var track  = slider.querySelector('[data-blog-featured-track]');
    var barsEl = container.querySelector('[data-blog-featured-bars]');
    var slides = Array.from(slider.querySelectorAll('[data-slide]'));
    var bars   = barsEl ? Array.from(barsEl.querySelectorAll('[data-bar]')) : [];
    var current = 0;
    var dragStartX = 0;
    var dragDeltaX = 0;
    var dragging = false;
    var threshold = 50;

    function goTo(idx) {
      if (bars[current]) bars[current].classList.remove('is-active');
      current = (idx + slides.length) % slides.length;
      track.style.transition = '';
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      if (bars[current]) bars[current].classList.add('is-active');
    }

    bars.forEach(function (bar) {
      bar.addEventListener('click', function () {
        goTo(parseInt(bar.dataset.bar, 10));
      });
    });

    slider.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') goTo(current + 1);
      if (e.key === 'ArrowLeft')  goTo(current - 1);
    });

    function dragStart(x) {
      dragging = true;
      dragStartX = x;
      dragDeltaX = 0;
      track.style.transition = 'none';
    }

    function dragMove(x) {
      if (!dragging) return;
      dragDeltaX = x - dragStartX;
      var pct = (dragDeltaX / slider.offsetWidth) * 100;
      track.style.transform = 'translateX(calc(-' + (current * 100) + '% + ' + pct + 'px))';
    }

    function dragEnd() {
      if (!dragging) return;
      dragging = false;
      track.style.transition = '';
      if (dragDeltaX < -threshold) goTo(current + 1);
      else if (dragDeltaX > threshold) goTo(current - 1);
      else track.style.transform = 'translateX(-' + (current * 100) + '%)';
    }

    /* Touch */
    slider.addEventListener('touchstart', function (e) { dragStart(e.touches[0].clientX); }, { passive: true });
    slider.addEventListener('touchmove',  function (e) { dragMove(e.touches[0].clientX); },  { passive: true });
    slider.addEventListener('touchend',   dragEnd);

    /* Mouse drag */
    slider.addEventListener('mousedown', function (e) { dragStart(e.clientX); });
    window.addEventListener('mousemove', function (e) { if (dragging) dragMove(e.clientX); });
    window.addEventListener('mouseup',   dragEnd);

    /* Prevent click-through on links after a drag */
    slider.addEventListener('click', function (e) {
      if (Math.abs(dragDeltaX) > 5) e.preventDefault();
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fyre-section-knowledgebase-faqs"] && !Shopify.designMode) return;
  try {
    
(function () {

  function openAnswer(answer) {
    answer.style.height = answer.scrollHeight + 'px';
    answer.classList.add('kb-faqs__answer--open');
  }

  function closeAnswer(answer) {
    answer.style.height = '0';
    answer.classList.remove('kb-faqs__answer--open');
  }

  document.querySelectorAll('[data-kb-faq]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item   = btn.closest('.kb-faqs__item');
      var answer = item.querySelector('[data-kb-faq-answer]');
      var icon   = btn.querySelector('.kb-faqs__question-icon');
      var isOpen = answer.classList.contains('kb-faqs__answer--open');

      if (isOpen) {
        closeAnswer(answer);
        icon.classList.replace('fa-minus', 'fa-plus');
        btn.setAttribute('aria-expanded', 'false');
      } else {
        openAnswer(answer);
        icon.classList.replace('fa-plus', 'fa-minus');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });

  window.addEventListener('resize', function () {
    document.querySelectorAll('[data-kb-faq-answer].kb-faqs__answer--open').forEach(function (answer) {
      answer.style.height = 'auto';
      var h = answer.scrollHeight;
      answer.style.height = h + 'px';
    });
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fyre-section-pdp-info"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-pdp-info]').forEach(function (container) {
    // Click → smooth scroll + open target toggle
    function jumpToPanel(panel) {
      // Scroll to the header first — its position is stable (content only expands below it).
      // Using scrollIntoView with scroll-margin-top: 100px defined in CSS.
      panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
      // Open after queuing the scroll so the header stays put as content reveals.
      if (!panel.classList.contains('pdp-toggle--open')) {
        var btn = panel.querySelector('[data-pdp-toggle-btn]');
        if (btn) btn.click();
      }
    }

    var links = container.querySelectorAll('[data-pdp-jump]');
    links.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var panel = document.getElementById(link.getAttribute('data-target'));
        if (panel) jumpToPanel(panel);
      });
    });

    // Mobile nav select
    var navSelect = container.querySelector('[data-pdp-nav-select]');
    if (navSelect) {
      navSelect.addEventListener('change', function () {
        var id = navSelect.value;
        if (!id) return;
        navSelect.value = '';
        var panel = document.getElementById(id);
        if (panel) jumpToPanel(panel);
      });
    }

  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fyre-template-blog"]) return;
  try {
    
(function () {
  function appendArticles(newGrid, grid) {
    var added = [];
    newGrid.querySelectorAll('.blog-listing__article').forEach(function (el) {
      el.classList.add('is-entering');
      grid.appendChild(el);
      added.push(el);
    });
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        added.forEach(function (el) { el.classList.remove('is-entering'); });
      });
    });
    return added.length;
  }

  function updateCount(wrap, addedCount) {
    var loaded = (parseInt(wrap.dataset.loaded) || 0) + addedCount;
    wrap.dataset.loaded = loaded;
    var countEl = wrap.querySelector('.blog-listing__load-more-count');
    if (countEl) countEl.textContent = 'Showing ' + loaded + ' of ' + wrap.dataset.total;
  }

  function loadArticles(url, gridId, trigger, onDone) {
    trigger.setAttribute('data-loading', '');
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc  = new DOMParser().parseFromString(html, 'text/html');
        var grid = document.getElementById(gridId);
        var next = doc.getElementById(gridId);
        var addedCount = 0;
        if (grid && next) addedCount = appendArticles(next, grid);
        trigger.removeAttribute('data-loading');
        var nextTrigger = doc.querySelector('[data-load-more], [data-scroll-sentinel]');
        onDone(nextTrigger ? nextTrigger.dataset.nextUrl : null, addedCount);
      });
  }

  /* Load More button */
  document.querySelectorAll('[data-load-more]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      loadArticles(btn.dataset.nextUrl, btn.dataset.gridId, btn, function (nextUrl, addedCount) {
        var wrap = btn.closest('[data-load-more-wrap]');
        if (wrap) updateCount(wrap, addedCount);
        if (nextUrl) {
          btn.dataset.nextUrl = nextUrl;
        } else {
          btn.closest('.blog-listing__load-more').remove();
        }
      });
    });
  });

  /* Infinite scroll */
  document.querySelectorAll('[data-scroll-sentinel]').forEach(function (sentinel) {
    function observe() {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.disconnect();
          loadArticles(sentinel.dataset.nextUrl, sentinel.dataset.gridId, sentinel, function (nextUrl, addedCount) {
            updateCount(sentinel, addedCount);
            if (nextUrl) {
              sentinel.dataset.nextUrl = nextUrl;
              observe();
            } else {
              sentinel.remove();
            }
          });
        });
      }, { rootMargin: '0px 0px -120px 0px' });
      observer.observe(sentinel);
    }
    observe();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
